import { render, staticRenderFns } from "./AvukatTalepPicker.vue?vue&type=template&id=00ad2f30"
import script from "./AvukatTalepPicker.vue?vue&type=script&lang=ts"
export * from "./AvukatTalepPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports